import React, { useMemo } from "react";
import { Formik } from "formik";
import { AsyncCheckPickerInput, Button, ErrorMessageField } from "@shared/components";
import { OptionWithData } from "@shared/interfaces";
import { SensorDataFile } from "@shared/models";

import { getInitValues, selectFileValidationSchema, handlers } from "./formHelpers";

import "./index.scss";

interface SelectFileModalProps {
  onClose: () => void;
  onSubmit: (values: OptionWithData<SensorDataFile>[]) => void;
}

const SelectFileModal = (props: SelectFileModalProps) => {
  const { onClose, onSubmit } = props;

  const initValues = useMemo(() => {
    return getInitValues();
  }, []);

  return (
    <div className="select-file-modal modal-content-wrapper">
      <div className="modal-heading">Select File</div>
      <Formik
        validationSchema={selectFileValidationSchema}
        enableReinitialize={true}
        validateOnBlur={false}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values.files);
          setSubmitting(false);
        }}
        initialValues={initValues}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="modal-content">
                <div className="form-rows">
                  <div className="files-column">
                    <AsyncCheckPickerInput
                      labelTitle="Files"
                      name="files"
                      className="check-picker"
                      placeholder="Files"
                      initOptions={initValues.files}
                      onChange={(v) => setFieldValue("files", v)}
                      values={values.files}
                      getData={handlers.files.getData}
                      selectData={handlers.files.selectData}
                      prepareOptionFunction={handlers.files.prepareOptionFunction}
                    />
                    <ErrorMessageField name="files" />
                  </div>
                </div>
              </div>
              <div className="modal-actions">
                <Button appearance="subtle" className="subtle auto-width" onClick={() => onClose()}>
                  Cancel
                </Button>
                <Button type="submit" className="blue auto-width">
                  Apply
                </Button>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default SelectFileModal;
